import React, { Component } from 'react';
import '../css/formats.css';
import { Datos_Empresa, development } from "../libs/utils/Const";

class FormatAdvancePaymentModal extends Component {

    render() {
        const { Print } = this.props;
        return (

            <div>
                <div className="modal fade" id="formatAdvancePaymentModal" data-keyboard="true" tabIndex="-1" aria-labelledby="formatAdvancePaymentModalLabel" aria-hidden="true" >
                    <div className="modal-dialog modal-xl" >
                        <div className="modal-content text-responsive">
                            <div className="modal-header">
                            </div>
                            <div className="modal-body scrollPage" id="printAP">
                                <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                                    
                                    <div className='text-right' style={{ fontSize: "14px" }}>
                                        <table>
                                        <tbody>
                                            <tr>
                                                <td className='text-right'>
                                                {"(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)"}
                                                </td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                    
                                    <div className="row">
                                        <div className="col-3">
                                            <img src={development? require('../images/logo_draft.svg') : require('../images/logo_EMPRESA.svg')} alt="Logo" />
                                            <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /><strong>${Datos_Empresa.RFC}</strong></p>
                                            <span className="text-left">Teléfono(s):</span>
                                            <p>COL. C.P.;,.</p>
                                        </div>
                                        <div className="col-4"></div>
                                        <div className="col-5">
                                            <table>
                                                <thead>
                                                    <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                        <th className="text-left">FOLIO FISCAL: </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="text-center">1DCDC122-AB98-4300-9F84-8C3D377A22EF</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table>
                                                <thead>
                                                    <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                        <th className="text-left">NO. SERIE DEL CSD: </th>
                                                        <th className="text-left">NO. SERIE DEL CSD DEL SAT: </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="text-center">00001000000507105517</td>
                                                        <td className="text-center">00001000000503727538</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table>
                                                <thead>
                                                    <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                        <th className="text-left">FECHA Y HORA DE CERTIFICACION: </th>
                                                        <th className="text-left">FOLIO COUNTER ONE: </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="text-center">2022-06-30T18:34:42</td>
                                                        <td className="text-center">CC0CCCAA2</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table>
                                                <thead>
                                                    <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                        <th className="text-left">RÉGIMEN FISCAL: </th>
                                                        <th className="text-left">FORMA DE PAGO: </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="text-center">-</td>
                                                        <td className="text-center">30 - Aplicacion de anticipos</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='row mt-4' style={{ paddingRight: "15px" }}>
                                        <span>2022-06-30 18:34:42</span>
                                        <table>
                                            <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                <tr>
                                                    <th className="text-center" colSpan="2">DATOS DEL CLIENTE</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><strong>NOMBRE: </strong>ROLLER HOUSE MEXICO SA DE CV</td>
                                                    <td><strong>CLAVE: </strong>CCC676</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>DOMICILIO: </strong>C. AV. LA MARINA, No. 411, Int. LOCAL4, Col. EL TOREO, Del. MAZATLAN C</td>
                                                    <td><strong>RUT: </strong>RHM160706LT4</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>CIUDAD: </strong>MAZATLAN, SIN</td>
                                                    <td><strong>PAÍs: </strong>MX <strong> C.P.: </strong>82120</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>AGENTE: </strong></td>
                                                    <td><strong>VENDEDOR INTERNO: </strong>MIRIAM ALTAMIRANO UREÑA</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>MONEDA: </strong>0 $</td>
                                                    <td><strong>COND. PAGO: </strong> <strong>FACTURA BASE: </strong> </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2"><strong>LUGAR DE ENTREGA: </strong>C. .., No. ., Int. .., ., SIN, MX</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table className='mt-5'>
                                            <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Cant.</th>
                                                    <th className="text-center">Código</th>
                                                    <th className="text-center">Descripción</th>
                                                    <th>UM</th>
                                                    <th>T.IMP</th>
                                                    <th className="text-right">Precio</th>
                                                    <th className="text-right">Importe</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>fsf</td>
                                                    <td>fsdf</td>
                                                    <td className="text-center">fsfs</td>
                                                    <td className="text-center">fsf</td>
                                                    <td>dfsdf</td>
                                                    <td>fsdfsd</td>
                                                    <td className="text-right">fsdf</td>
                                                    <td className="text-right">dfsdf</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-9'>
                                            <p>
                                                Importe con letra: <br />
                                                VEINTICUATRO MIL OCHOCIENTOS SESENTA Y SIETE PES.<br />
                                                <br />
                                                <br />
                                                <br />
                                                <strong>"ESTE DOCUMENTO ES UNA REPRESENTACION IMPRESA DE UN CFDI"</strong><br />
                                                <strong>Método de pago: </strong>PUE - Pago en una sola exhibición<br />
                                                <strong>Método de pago: </strong>PUE - Pago en una sola exhibición<br />
                                                Comentarios: Basado en operación de Counter One CC0CCCAA2<br />
                                                <br />
                                            </p>
                                        </div>
                                        <div className='col-3'>
                                            <table>

                                                <tbody>
                                                    <tr>
                                                        <td className='text-right'><strong>Subtotal: </strong></td>
                                                        <td className='text-right'>fsdf</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-right'><strong>Impuesto: </strong></td>
                                                        <td className='text-right'>fsdf</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-right'><strong>Total: </strong></td>
                                                        <td className='text-right'>fsdf</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='row' style={{ marginLeft: "-30px" }}>
                                        <div className='col-12'>
                                            <table>
                                                <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                    <tr>
                                                        <th className="text-center">Sello Digital del Emisor:</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='digitalStampMax'>
                                                            LPVgztJApLdzw3vxVM1cJKD+DazyOKvRBb3SVboB69Ei5L3mLMxj9uvfE9yLbaIpCD5Qdrqy0nwkvJtsWEv7/a46zvTLO8r6JYE0sJWahoI5XuSh32CrDIhGad4gIQgwOHok31By6I3bl+8OR0uKvGBgSUr2CeQaeDgX1mTn48/5Xo6+dcNjrGddtUIt4fnUq+XZKhuFa5WuScJbv3LeO7321he2yGUET5+6twlYsVbSJ1qsZfysq1GHIpKhYqYH83z3WCYDB6sWwARtzMgaNtCpWlXam6Gs+7KOAKzAVfDs9y3UJE6jlrfnUeKjxmsqS7WxfnvDPgR62RKWQ/j4Yw=
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='row mt-2' style={{ marginLeft: "-30px" }}>
                                        <div className='col-12'>
                                            <table>
                                                <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                    <tr>
                                                        <th className="text-center">Sello Digital del SAT:</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='digitalStampMax'>
                                                            LPVgztJApLdzw3vxVM1cJKD+DazyOKvRBb3SVboB69Ei5L3mLMxj9uvfE9yLbaIpCD5Qdrqy0nwkvJtsWEv7/a46zvTLO8r6JYE0sJWahoI5XuSh32CrDIhGad4gIQgwOHok31By6I3bl+8OR0uKvGBgSUr2CeQaeDgX1mTn48/5Xo6+dcNjrGddtUIt4fnUq+XZKhuFa5WuScJbv3LeO7321he2yGUET5+6twlYsVbSJ1qsZfysq1GHIpKhYqYH83z3WCYDB6sWwARtzMgaNtCpWlXam6Gs+7KOAKzAVfDs9y3UJE6jlrfnUeKjxmsqS7WxfnvDPgR62RKWQ/j4Yw=
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='row mt-2' style={{ marginLeft: "-30px" }}>
                                        <div className='col-12'>
                                            <table>
                                                <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                    <tr>
                                                        <th className="text-center">Cadena Original del complemento de certificación digital del SAT</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='digitalStampMax'>
                                                            LPVgztJApLdzw3vxVM1cJKD+DazyOKvRBb3SVboB69Ei5L3mLMxj9uvfE9yLbaIpCD5Qdrqy0nwkvJtsWEv7/a46zvTLO8r6JYE0sJWahoI5XuSh32CrDIhGad4gIQgwOHok31By6I3bl+8OR0uKvGBgSUr2CeQaeDgX1mTn48/5Xo6+dcNjrGddtUIt4fnUq+XZKhuFa5WuScJbv3LeO7321he2yGUET5+6twlYsVbSJ1qsZfysq1GHIpKhYqYH83z3WCYDB6sWwARtzMgaNtCpWlXam6Gs+7KOAKzAVfDs9y3UJE6jlrfnUeKjxmsqS7WxfnvDPgR62RKWQ/j4Yw=
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => setTimeout(Print, 500)}>Imprimir</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormatAdvancePaymentModal;